<script>
import { Money } from "v-money";

export default {
  components: {
    Money
  },
  props: { label: { type: String, required: true, default: "money" } },

  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        precision: 2,
        masked: false /* doesn't work with directive */
      },
      value: ""
    };
  },

  watch: {
    value(val) {
      this.value = val;
      this.$emit("input", this.value);
    }
  }
};
</script>

<template>
  <v-text-field
    name="value"
    v-model="value"
    :label="this.label"
    v-money="money"
    prefix="R$"
    required
  />
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/_Shared/Forms/Currency.vue